import '@/app/styles/global.css'
import '@/app/styles/workbench.css'
import { bootstrap } from '@/app/bootstrap'

bootstrap()
